import React from 'react';
import { FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';
import logo from '../Assets/lakenriver_logo-copy-2.webp';
import { Link } from 'react-router-dom';
import OptionCards from './OptionCards';

const Footer = () => {
  return (
    <>
      <OptionCards />
      <footer className="bg-green-950 text-white px-6 md:px-16 py-10 relative">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Logo & Socials */}
          <div>
            <img src={logo} loading="lazy" alt="Lake n River Logo" className="mb-4 w-40" />
            <p className="mb-4">Munroe Island, Kollam, Kerala 691502</p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/skbmunroeisland?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer" className="bg-green-500 p-2 rounded-full"><FaFacebookF /></a>
              <a href="https://www.instagram.com/lakenriver.resort.munroeisland/" target="_blank" rel="noopener noreferrer" className="bg-green-500 p-2 rounded-full"><FaInstagram /></a>
              <a href="https://www.youtube.com/@lakenriverresortmunroeisla8334" target="_blank" rel="noopener noreferrer" className="bg-green-500 p-2 rounded-full"><FaYoutube /></a>
              <a href="https://wa.me/918848207990" target="_blank" rel="noopener noreferrer" className="bg-green-500 p-2 rounded-full"><FaWhatsapp /></a>
            </div>
          </div>

          {/* Explore Links */}
          <div>
            <h3 className="text-xl text-cyan-400 font-medium mb-4">Explore</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:underline">Home</Link></li>
              <li><Link to="/escape-plan" className="hover:underline">Escape Plan</Link></li>
              <li><Link to="/contact-us" className="hover:underline">Contact</Link></li>
              <li><Link to="/highlights" className="hover:underline">Highlights</Link></li>
              <li><Link to="/faqs" className="hover:underline">FAQ's</Link></li>
            </ul>
          </div>

          {/* Address & Contact */}
          <div>
            <h3 className="text-xl text-cyan-400 font-medium mb-4">Address</h3>
            <p className="mb-4">Munroe Island, Kollam, Kerala 691502</p>
            <h3 className="text-xl text-cyan-400 font-medium mb-2">Contact</h3>
            <p className="mb-1">
              <a href="https://wa.me/+918848207990" target="_blank" rel="noopener noreferrer">+91 8848207990</a>
            </p>
            <p>
              <a href="mailto:enquiry@lakenriver.com" target="_blank" rel="noopener noreferrer">enquiry@lakenriver.com</a>
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-green-700 mt-10 pt-4 flex flex-col md:flex-row justify-between text-sm">
          <p>
            &copy; 2024 Lake N River Resorts crafted by{" "}
            <a href="https://happyclicks.in/" target="_blank" rel="noopener noreferrer">Happy Clicks</a>
          </p>
          <div className="space-x-4">
            <a href="#" className="text-cyan-400 hover:underline">Privacy Policy</a>
            <a href="#" className="text-cyan-400 hover:underline">Terms & Services</a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
